import L from "leaflet";
import { getSymbolPath } from "@/config/sitac";
import type { SITACSymbolWithCategory } from "../../components/SITAC/SITACSymbolSelector";

export function createSITACIcon(
  symbol: SITACSymbolWithCategory,
  rotation: number = 0,
  scale: number = 1
): L.DivIcon {
  const size = 48 * scale;

  return L.divIcon({
    html: `<img src="${getSymbolPath(symbol.categoria, symbol.file)}" 
           style="width: ${size}px; 
                  height: ${size}px; 
                  object-fit: contain; 
                  transform: rotate(${rotation}deg);
                  transition: transform 0.2s;" />`,
    className: "sitac-marker",
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });
}